import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './Contactos.css';

const Contactos = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    celular: '',
    mensaje: ''
  });

  const recaptchaRef = useRef();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const captchaToken = window.grecaptcha.getResponse();

    if (!captchaToken) {
      alert('Por favor, completa el reCAPTCHA');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/contact/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          nombre: formData.nombre,
          apellido: formData.apellido,
          email: formData.email,
          mensaje: formData.mensaje,
          captcha_token: captchaToken
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        alert('Mensaje enviado correctamente');
        setFormData({ nombre: '', apellido: '', email: '', celular: '', mensaje: '' });
        window.grecaptcha.reset();
      } else {
        alert(data.message || 'Error al enviar el mensaje');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error de conexion. Por favor intente nuevamente.');
    }
  };

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="contact-container reveal-on-scroll">
          <h1>Contactos</h1>
        </div>
      </section>

      <section className="contact-info-block">
        <div className="contact-container contact-info-grid">
          <article className="contact-info-card reveal-on-scroll">
            <h3>Telefonos</h3>
            <p>381-2621036</p>
          </article>

          <article className="contact-info-card reveal-on-scroll">
            <h3>Mails</h3>
            <p>
              <a href="mailto:mesadeentradas@dpatuc.com">mesadeentradas@dpatuc.com</a>
            </p>
          </article>

          <article className="contact-info-card reveal-on-scroll">
            <h3>Direccion</h3>
            <p>Simon Bolivar 1095</p>
            <p>San Miguel de Tucuman, Tucuman</p>
          </article>

          <article className="contact-info-card reveal-on-scroll">
            <h3>Horario</h3>
            <p>Lunes a Viernes</p>
            <p>08:00 a 16:00 Hs</p>
          </article>
        </div>
      </section>

      <section className="contact-main">
        <div className="contact-container contact-main-grid">
          <article className="contact-panel reveal-on-scroll">
            <h2>Contactenos</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nombre">Nombre *</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    placeholder="Coloque su nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="apellido">Apellido</label>
                  <input
                    type="text"
                    id="apellido"
                    name="apellido"
                    placeholder="Coloque su apellido"
                    value={formData.apellido}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email">Correo electronico *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Ingrese un correo valido"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="mensaje">Mensaje *</label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  placeholder="Escriba su mensaje aqui..."
                  value={formData.mensaje}
                  onChange={handleChange}
                  rows="5"
                  required
                />
              </div>

              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                size="normal"
                ref={recaptchaRef}
                className="recaptcha-separado"
              />

              <button type="submit" className="enviar-btn">
                Enviar
              </button>
            </form>
          </article>

          <article className="contact-panel reveal-on-scroll">
            <h2>Ubicacion</h2>
            <div className="mapa-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3560.1234567890123!2d-65.216082!3d-26.838327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94225d3ad7f30f1d%3A0xf8606cd659b8e3e!2sSim%C3%B3n%20Bol%C3%ADvar%201095%2C%20San%20Miguel%20de%20Tucum%C3%A1n%2C%20Tucum%C3%A1n!5e0!3m2!1ses-419!2sar!4v1234567890123!5m2!1ses-419!2sar"
                width="100%"
                height="470"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicacion DPA Tucuman"
              />
            </div>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Contactos;
